export enum CalculatorInterestType {
    Combined, // Samengesteld
    Singular // Enkelvoudig
}
